import {
  LAYOUTS,
  MENU_SECTIONS,
  MODULE_SETTINGS,
  USER_ROLES,
} from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";
import { PORTFOLIO_ROUTE_NAMES } from "./routeNames";

const routes: AppRouteRecordRaw[] = [
  {
    name: PORTFOLIO_ROUTE_NAMES.STUDENT_PORTFOLIO_INDEX,
    path: "/portfolio",
    component: () => import("views/EmptyView.vue"),
    redirect: { name: "studentPortfolio" },
    meta: {
      title: "Mijn portfolio",
      roleRequired: [USER_ROLES.STUDENT],
      isMenuItem: true,
      menuSection: MENU_SECTIONS.MAIN,
      menuOrder: 9,
      settingRequired: [MODULE_SETTINGS.PORTFOLIO],
      icon: "/images/menu/portfolio.svg",
      studentView: true,
    },
    children: [
      {
        name: "studentPortfolio",
        path: "",
        component: () => import("portfolio/pages/StudentProfilePage.vue"),
        meta: {
          title: "Mijn portfolio",
          roleRequired: [USER_ROLES.STUDENT],
          settingRequired: [MODULE_SETTINGS.PORTFOLIO],
          layout: LAYOUTS.PORTFOLIO,
        },
      },
      {
        name: "studentCreateActivity",
        path: "activity/create",
        component: () =>
          import("portfolio/pages/StudentCreateActivityPage.vue"),
        meta: {
          title: "Activiteit toevoegen",
          roleRequired: [USER_ROLES.STUDENT],
          settingRequired: [MODULE_SETTINGS.PORTFOLIO],
          hideSubmenu: true,
          hideTitle: true,
          layout: LAYOUTS.PORTFOLIO,
        },
      },
      {
        name: "studentEditActivity",
        path: "activity/:activityId/edit",
        component: () => import("portfolio/pages/StudentEditActivityPage.vue"),
        meta: {
          title: "Activiteit bewerken",
          roleRequired: [USER_ROLES.STUDENT],
          settingRequired: [MODULE_SETTINGS.PORTFOLIO],
          hideSubmenu: true,
          hideTitle: true,
          layout: LAYOUTS.PORTFOLIO,
        },
      },
    ],
  },
  {
    path: "/my-tasks",
    name: "studentTasks",
    component: () => import("views/EmptyView.vue"),
    redirect: {
      name: "studentOpenAssignments",
    },
    meta: {
      title: "Mijn taken",
      roleRequired: [USER_ROLES.STUDENT],
      isMenuItem: true,
      inDropdown: true,
      hasSubmenu: true,
      menuSection: MENU_SECTIONS.MAIN,
      menuOrder: 12,
      settingRequired: [MODULE_SETTINGS.PORTFOLIO],
      icon: "/images/menu/tasks.svg",
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      studentView: true,
    },
    children: [
      {
        name: "studentOpenAssignments",
        path: "open",
        component: () =>
          import("portfolio/pages/StudentOpenAssignmentsPage.vue"),
        meta: {
          title: "Mijn taken",
          tabLabel: "Openstaande taken",
          roleRequired: [USER_ROLES.STUDENT],
          inDropdown: true,
          settingRequired: [MODULE_SETTINGS.PORTFOLIO],
        },
      },
      {
        name: "studentAwaitingAssessmentAssignments",
        path: "awaiting-assessment",
        component: () =>
          import("portfolio/pages/StudentAwaitingAssessmentAssignmentsPage.vue"),
        meta: {
          title: "Mijn taken",
          tabLabel: "Wachtend op beoordeling",
          roleRequired: [USER_ROLES.STUDENT],
          inDropdown: true,
          settingRequired: [MODULE_SETTINGS.PORTFOLIO],
        },
      },
      {
        name: "studentCompletedAssignments",
        path: "completed",
        component: () =>
          import("portfolio/pages/StudentCompletedAssignmentsPage.vue"),
        meta: {
          title: "Mijn taken",
          tabLabel: "Afgeronde taken",
          roleRequired: [USER_ROLES.STUDENT],
          inDropdown: true,
          settingRequired: [MODULE_SETTINGS.PORTFOLIO],
        },
      },
      {
        name: PORTFOLIO_ROUTE_NAMES.STUDENT_ASSIGNMENT,
        path: ":assignmentId",
        component: () => import("portfolio/pages/StudentAssignmentPage.vue"),
        meta: {
          roleRequired: [USER_ROLES.STUDENT],
          settingRequired: [MODULE_SETTINGS.PORTFOLIO],
          hideSubmenu: true,
          hideTitle: true,
        },
      },
      {
        path: ":assignmentId/edit",
        name: "studentEditAssignment",
        component: () =>
          import("portfolio/pages/StudentEditAssignmentPage.vue"),
        meta: {
          title: "Opdracht toevoegen",
          roleRequired: [USER_ROLES.STUDENT],
          settingRequired: [MODULE_SETTINGS.PORTFOLIO],
          hideSubmenu: true,
          hideTitle: true,
        },
      },
      {
        path: ":assignmentId/create",
        name: "studentCreateAssignment",
        component: () =>
          import("portfolio/pages/StudentCreateAssignmentPage.vue"),
        meta: {
          title: "Opdracht toevoegen",
          roleRequired: [USER_ROLES.STUDENT],
          settingRequired: [MODULE_SETTINGS.PORTFOLIO],
          hideSubmenu: true,
          hideTitle: true,
        },
      },
    ],
  },
];

export default routes;
